
import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { Separator } from "@/components/ui/separator";

const PolitiqueConfidentialite = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <SEO 
        title="Politique de Confidentialité | Groupe Fabre Environnement"
        description="Découvrez comment le Groupe Fabre Environnement protège vos données personnelles et respecte votre vie privée."
        canonical="/politique-confidentialite"
      />
      <Navbar />
      <main className="flex-grow pt-24">
        <div className="container mx-auto px-4 py-12">
          <h1 className="text-3xl md:text-4xl font-heading font-bold mb-8 text-fabre-gray">
            Politique de Confidentialité
          </h1>
          
          <Separator className="mb-8" />
          
          <div className="prose prose-lg max-w-none">
            <p className="lead">
              Le Groupe Fabre Environnement s'engage à protéger votre vie privée et à traiter vos données personnelles avec le plus grand soin et en toute transparence.
            </p>

            <h2 className="text-2xl font-heading font-bold mb-4 mt-8 text-fabre-gray">Collecte des données personnelles</h2>
            <p>
              Nous collectons les données personnelles suivantes :
            </p>
            <ul>
              <li>Nom et prénom</li>
              <li>Adresse email</li>
              <li>Numéro de téléphone</li>
              <li>Adresse postale</li>
              <li>Données de connexion et de navigation sur le site</li>
            </ul>
            <p>
              Ces données sont collectées lorsque vous :
            </p>
            <ul>
              <li>Remplissez un formulaire de contact</li>
              <li>Demandez un devis</li>
              <li>Vous inscrivez à notre newsletter</li>
              <li>Naviguez sur notre site (via les cookies)</li>
            </ul>

            <h2 className="text-2xl font-heading font-bold mb-4 mt-8 text-fabre-gray">Utilisation des données</h2>
            <p>
              Vos données personnelles sont utilisées pour :
            </p>
            <ul>
              <li>Répondre à vos demandes d'information</li>
              <li>Vous fournir les services demandés (devis, prestations, etc.)</li>
              <li>Vous envoyer notre newsletter si vous y avez consenti</li>
              <li>Améliorer notre site et nos services</li>
              <li>Personnaliser votre expérience utilisateur</li>
              <li>Établir des statistiques de visite</li>
            </ul>

            <h2 className="text-2xl font-heading font-bold mb-4 mt-8 text-fabre-gray">Conservation des données</h2>
            <p>
              Nous conservons vos données personnelles pendant une durée n'excédant pas celle nécessaire aux finalités pour lesquelles elles sont collectées et traitées.
            </p>
            <p>
              Les données relatives aux clients sont conservées pendant la durée de la relation commerciale et pendant 3 ans après le dernier contact.
            </p>
            <p>
              Les données relatives aux prospects sont conservées pendant 3 ans à compter de leur collecte ou du dernier contact.
            </p>

            <h2 className="text-2xl font-heading font-bold mb-4 mt-8 text-fabre-gray">Partage des données personnelles</h2>
            <p>
              Nous ne vendons ni ne louons vos données personnelles à des tiers. Vos données peuvent être transmises à des sous-traitants qui agissent selon nos instructions et pour notre compte.
            </p>
            <p>
              Nous pouvons être amenés à divulguer vos données personnelles si la loi nous y oblige ou dans le cadre d'une procédure judiciaire.
            </p>

            <h2 className="text-2xl font-heading font-bold mb-4 mt-8 text-fabre-gray">Droits des utilisateurs</h2>
            <p>
              Conformément à la réglementation européenne en vigueur, vous disposez des droits suivants :
            </p>
            <ul>
              <li>Droit d'accès : vous pouvez obtenir des informations concernant le traitement de vos données personnelles ainsi qu'une copie de ces données.</li>
              <li>Droit de rectification : si vous estimez que vos données personnelles sont inexactes ou incomplètes, vous pouvez exiger que ces données soient modifiées en conséquence.</li>
              <li>Droit à l'effacement : vous pouvez exiger l'effacement de vos données personnelles dans les limites prévues par la loi.</li>
              <li>Droit à la limitation du traitement : vous pouvez demander la limitation du traitement de vos données personnelles.</li>
              <li>Droit d'opposition : vous pouvez vous opposer au traitement de vos données personnelles pour des motifs liés à votre situation particulière.</li>
              <li>Droit à la portabilité des données : vous avez le droit de recevoir vos données personnelles dans un format structuré, couramment utilisé et lisible par machine.</li>
            </ul>
            <p>
              Pour exercer ces droits, vous pouvez nous contacter à l'adresse email : contactgfe@groupefabre.com ou par courrier à l'adresse : Groupe Fabre Environnement, 12000 Rodez, France.
            </p>

            <h2 className="text-2xl font-heading font-bold mb-4 mt-8 text-fabre-gray">Sécurité des données</h2>
            <p>
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées afin de garantir un niveau de sécurité adapté au risque, y compris entre autres :
            </p>
            <ul>
              <li>Le chiffrement des données personnelles</li>
              <li>Des moyens permettant de garantir la confidentialité, l'intégrité et la disponibilité constantes des systèmes et des services de traitement</li>
              <li>Des moyens permettant de rétablir la disponibilité des données personnelles et l'accès à celles-ci dans des délais appropriés en cas d'incident physique ou technique</li>
              <li>Une procédure visant à tester, à analyser et à évaluer régulièrement l'efficacité des mesures techniques et organisationnelles pour assurer la sécurité du traitement</li>
            </ul>

            <h2 className="text-2xl font-heading font-bold mb-4 mt-8 text-fabre-gray">Modification de notre politique de confidentialité</h2>
            <p>
              Nous nous réservons le droit de modifier la présente politique de confidentialité à tout moment. Toute modification sera publiée sur cette page. Nous vous encourageons à consulter régulièrement cette politique pour vous tenir informé de tout changement.
            </p>

            <p className="mt-8">
              Date de dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PolitiqueConfidentialite;
